<template>
  <MarketSegmentRadioField :choices="choices" v-on="$listeners" />
</template>

<script>
import MarketSegmentRadioField from 'chimera/all/components/form/fields/marketSegment/MarketSegmentRadioField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'MarketSegmentFormPart',

  components: {
    MarketSegmentRadioField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable('Particulier', 'Particulier', 'Particulier'),
        new Selectable('Zakelijk', 'Zakelijk', 'Zakelijk'),
      ],
    }
  },
}
</script>
